import type { HelpFile } from '../../types/help'
import { ConnectorAttributesTabTestIds } from '../../../testids/ConnectorAttributesTabTestIds'

export const connectorAttributesTabHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorAttributesTabTestIds.cardTitleConnectorAttributes]: 'Attributzuordnungen dieses Konnektors — wie Identitätsattribute bei der Provisionierung auf Felder des Zielsystems abgebildet werden.',
  },
}
